var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "errors-forbidden-view"
  }, [_c('h1', [_vm._v("\n    " + _vm._s(_vm.$t('error.titles.forbidden')) + "\n  ")]), _vm._v(" "), _c('alert-box', {
    attrs: {
      "type": "warning",
      "icon": "lock"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('error.hints.forbidden')) + "\n  ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed81aee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./views/Errors/ForbiddenView.vue
// module id = 2044
// module chunks = 0